import { formatCrawlAt } from '@components/SitemapReport/schedule'
import { Tooltip } from '@octopus-do/octopus-storybook'
import { Pulse } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  lastCrawlAt?: null | string
  nextCrawlAt?: null | string
}

const toDate = (value?: null | string) => {
  const date = value ? new Date(value) : null

  return date && !Number.isNaN(date.getTime()) ? date : null
}

// The tooltip takes its label as a string, so the lines are kept apart by the
// spaces: inside a line they do not break, and two lines are too wide to share
// the tooltip's width — it can only wrap between them.
const line = (text: string) => text.replaceAll(' ', '\u00a0')

// Sits under the shared marker on a report card: the report re-crawls on a
// schedule, so the card says when it was last crawled and when the next crawl
// is due without opening the report. An older API answers without the next
// date, and then the marker can only say that crawls are scheduled at all.
export const ScheduleMarker: React.FC<Props> = ({
  lastCrawlAt,
  nextCrawlAt,
}) => {
  const last = toDate(lastCrawlAt)
  const next = toDate(nextCrawlAt)

  const label = [
    last && line(`Last crawl: ${formatCrawlAt(last)}`),
    line(next ? `Next crawl: ${formatCrawlAt(next)}` : 'Scheduled crawls'),
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Tooltip label={label} multiline>
      <div className={css.icon_wrap}>
        <Pulse />
      </div>
    </Tooltip>
  )
}
